const canonicalCount = (value) => (
  value !== null && value !== undefined && value !== ''
  && Number.isFinite(Number(value)) && Number(value) >= 0
    ? Number(value)
    : null
);

const countLabel = (value, label) => {
  const count = canonicalCount(value);
  return count === null ? '' : `${count} ${label}`;
};

/** Build compact supplemental metadata from canonical Project totals. */
export const buildProjectRowMetadata = (project = {}) => (
  [
    countLabel(project.session_count, '会话'),
    countLabel(project.artifact_count, '产物'),
  ].filter(Boolean).join(' · ')
);
